import React from 'react';

type Status = 'active' | 'done' | 'pending';

interface StatusBadgeProps {
  status: Status;
}

const statusStyles: Record<Status, string> = {
  active: 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 border-0 shadow-soft',
  done: 'bg-gray-100 dark:bg-dark-300 text-gray-600 dark:text-gray-400 border-0 shadow-soft',
  pending: 'bg-warm-400 dark:bg-dark-purple-300/80 text-soft-black dark:text-dark-purple-100 border-0 shadow-soft',
};

const statusLabels: Record<Status, string> = {
  active: 'Ativa',
  done: 'Concluída',
  pending: 'Pendente',
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  return (
    <span className={`px-4 py-2 rounded-full text-xs font-semibold ${statusStyles[status]}`}>
      {statusLabels[status]}
    </span>
  );
};
